import { Capabilities, JobScope } from "src/hooks/useCapabilities/types";

type JobCapabilities = Capabilities["jobs"];

/** Whether the Job is editable at all, regardless of the deploy access an active Job takes. */
export const canEditJobDetails = (
  jobs: JobCapabilities,
  scope: JobScope,
): boolean => jobs.canEdit({ ...scope, isActive: false });

/** Whether schedules are manageable at all, regardless of the deploy access an active Job takes. */
export const canManageJobSchedule = (
  jobs: JobCapabilities,
  scope: JobScope,
): boolean =>
  jobs.canChangeSchedule({ ...scope, isActive: false }) ||
  jobs.canChangeSchedule({ ...scope, isActive: true });
